import { Tabs } from 'expo-router';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAuth } from '@/hooks/useAuth';
import { useStudentConversation } from '@/hooks/useStudentConversation';
import { HamburgerDrawer } from '@/components/HamburgerDrawer';

function StudentMenuButton() {
  const { profile, signOut } = useAuth();
  const { unreadStudent } = useStudentConversation(profile?.id ?? '', false);
  // Se o user logado é personal (espelhando a UI do aluno via "Meu treino"),
  // mostra o atalho de volta pro modo personal.
  const isPersonal = profile?.role === 'personal';
  return (
    <HamburgerDrawer
      role="student"
      unreadCount={unreadStudent}
      conversationTarget="/(student)/chat"
      profileTarget="/(student)/profile"
      financesTarget="/(student)/(tabs)/financeiro"
      backToPersonalTarget={isPersonal ? '/(personal)/(tabs)' : undefined}
      onSignOut={signOut}
    />
  );
}

export default function StudentTabsLayout() {
  const insets = useSafeAreaInsets();
  const bottomPad = Math.max(insets.bottom, 8);
  return (
    <Tabs screenOptions={{
      tabBarActiveTintColor: '#C8102E',
      headerRight: () => <StudentMenuButton />,
      headerRightContainerStyle: { paddingRight: 16 },
      tabBarStyle: { height: 56 + bottomPad, paddingBottom: bottomPad, paddingTop: 6 },
    }}>
      <Tabs.Screen
        name="index"
        options={{
          title: 'Treinos',
          tabBarLabel: 'Hoje',
          tabBarIcon: ({ color, size }) => <Ionicons name="barbell-outline" size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="progress/index"
        options={{
          title: 'Progresso',
          tabBarLabel: 'Progresso',
          tabBarIcon: ({ color, size }) => <Ionicons name="trending-up-outline" size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="photos/index"
        options={{
          title: 'Fotos',
          tabBarLabel: 'Evolução',
          tabBarIcon: ({ color, size }) => <Ionicons name="images-outline" size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="history/index"
        options={{
          title: 'Histórico',
          tabBarLabel: 'Histórico',
          tabBarIcon: ({ color, size }) => <Ionicons name="calendar-outline" size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="financeiro/index"
        options={{
          title: 'Financeiro',
          href: null, // escondido da tab bar; acessado via hamburguer
        }}
      />
    </Tabs>
  );
}
